export type TSortable = 'createdAt';

export const sortedFields = {
  createdAt: 'createdAt',
};
